import cateGraphQLClient from '@/graphql/cate/client'
import { PotentialPropertiesBySimilarQuery } from '@/types/cate-graphql-generated-types'

export async function fetchPrioritiesBySimilar(args: {
  areaMax: number
  areaMin: number
  geoSlugs: string[] | string
  priceMax: number
  priceMin: number
  roomsMax: number
  roomsMin: number
}): Promise<PotentialPropertiesBySimilarQuery['potential_property']> {
  const { areaMax, areaMin, geoSlugs, priceMax, priceMin, roomsMax, roomsMin } = args

  const response = await cateGraphQLClient.potentialPropertiesBySimilar({
    areaMax,
    areaMin,
    geoSlugs,
    priceMax,
    priceMin,
    roomsMax,
    roomsMin,
  })

  return response.data.potential_property
}
